import { Box, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

export const DetailsListItem = ({ title, value }: { title: string; value: ReactNode }) => (
  <Stack
    direction="row"
    sx={({ palette }) => {
      return {
        borderTop: `1px solid ${palette.border.main}`,
        flex: 0,
        py: 1.5,
      };
    }}
    data-testid="details-list-item"
  >
    <Box
      sx={{
        alignItems: 'baseline',
        flex: '0 0 100px',
      }}
    >
      <Typography fontWeight="bold" variant="subtitle2">
        {title}
      </Typography>
    </Box>
    <Box sx={{ width: '100%' }}>
      {typeof value === 'string' || typeof value === 'number' ? (
        <Typography variant="subtitle2">{value}</Typography>
      ) : (
        value
      )}
    </Box>
  </Stack>
);
